import { ReactElement, useMemo } from 'react'
import { HelperText, StyledInputGroup } from './styles'
import { InputGroupProps } from './props'
import { Input, Label, SVG, SVGs } from '../..'
import { checkedTypes } from '../../Atoms/Input/props'
import DataList from '../../Atoms/DataList'

const InputGroup = ({
    error,
    helperText,
    id,
    label,
    labelPlacement = 'inside',
    helperPlacement = 'left',
    placeholder = ' ',
    suggestions,
    ...props
}: InputGroupProps): ReactElement => {
    const generatedId = useMemo(
        () => id ?? `rr-input-group-${Math.random().toString(36).slice(2)}`,
        [id]
    )

    const labelDiv = useMemo(
        () =>
            label && (
                <Label htmlFor={generatedId}>
                    {label}
                    {props.required && '*'}
                </Label>
            ),
        [generatedId, label, props.required]
    )

    const helperDiv = useMemo(
        () =>
            helperText && (
                <HelperText helperPlacement={helperPlacement}>
                    {error && <SVG src={SVGs.Exclamation} />} {helperText}
                </HelperText>
            ),
        [error, helperPlacement, helperText]
    )

    const { type } = props
    const isTextInputWithSuggestions =
        type === 'text' && suggestions !== undefined

    return (
        <StyledInputGroup
            error={error}
            hasLabel={label ? true : false}
            labelPlacement={labelPlacement}
            isChecked={(checkedTypes as ReadonlyArray<string>).includes(
                props.type ?? ''
            )}
        >
            {['start', 'top'].includes(labelPlacement) && labelDiv}
            <Input
                {...props}
                error={error}
                id={generatedId}
                placeholder={placeholder === '' ? ' ' : placeholder}
                {...(isTextInputWithSuggestions && { list: suggestions.key })}
            />
            {isTextInputWithSuggestions && (
                <DataList id={suggestions.key} values={suggestions.list} />
            )}
            {['bottom', 'end', 'inside'].includes(labelPlacement) && labelDiv}
            {!(checkedTypes as ReadonlyArray<string>).includes(
                props.type ?? ''
            ) && helperDiv}
        </StyledInputGroup>
    )
}

export default InputGroup

export { StyledInputGroup }
